import { dbh_ajax } from "Ressources/dbh_ajax";
import { dbh_helper } from "Ressources/dbh_helper";
import { dbh_custom_validation } from '../ClientValidation/dbh_custom_validation';
import { start } from "repl";
import { dbh_suchergebnis } from "../Controls/dbh_suchergebnis";


if (dbh_helper.getUrlArea() == "belegungen") {
    $("#dbh_belegungenDetails").ready(function () {
        if ($("#dbh_belegungenDetails") && $("#dbh_belegungenDetails").length > 0) {
            let id = dbh_helper.getUrlParameter("id");
            if (id != "") {

                BindTableAndPopupFunctions(id);
                dbh_helper.OnSetDefaultFormValues = () => {
                    BindTableAndPopupFunctions(id);
                };

                $('#txtNeuerKommentar').off("keydown");
                $("#txtNeuerKommentar").keydown(function (e) {
                    var keycode = (e.keyCode ? e.keyCode : (e.which ? e.which : e.charCode));
                    if (keycode == 13) {
                        document.getElementById("btnNeuerKommentar").click();
                        return false;
                    }
                });

                $('#FK_Pflegesatzgruppen,#WochenStundenString').off("change");
                $('#FK_Pflegesatzgruppen,#WochenStundenString').on("change", function () {
                    alert("Achtung: Nach Wechsel der Pfelgesatzgruppe bzw. bei Änderung der Stunden müssen ggf. die KoordinatorInnen Stunden angepasst werden. Dies kann nur von AdministratorInnen vorgenommen werden. Wenn die Stunden der KoordinatorInnen auf 0 gesetzt werden, wird nach 'Speichern' versucht, diese automatisiert zu berechnen.")
                });

                $('#btnNeuerKommentar').off("click");
                $('#btnNeuerKommentar').on("click", function () {
                    if ($('#txtNeuerKommentar').val().toString().trim() != "") {
                        let form = dbh_helper.findNearestForm(this);
                        let paramString: string = "pk_jugendlicher=" + $(this).attr('data-pkadressen') + "&neuerKommentar=" + encodeURIComponent($('#txtNeuerKommentar').val().toString());

                        if (form) {
                            var ajax: dbh_ajax = new dbh_ajax();
                            ajax.sendPostRequest({
                                csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val().toString() : '',
                                actionName: "NeuerKommentar",
                                controllerName: "Belegungen",
                                parameter: paramString,
                                loadingTarget: "BoxKommetare",
                                callbackSuccess: (ajaxResult) => {
                                    let lbl = $('#lblKommentare');
                                    let obj = $("<span>");
                                    obj.hide();
                                    obj.html(ajaxResult);

                                    // wenn keine Daten vorhanden waren, dann steht nur der Platzhalter mit startendem <p> im Inhalt
                                    // dann soll der Inhalt ersetzt werden
                                    if (lbl.find('.keinKommentar').length > 0) {
                                        lbl.html("");
                                    }

                                    lbl.prepend(obj);
                                    obj.fadeIn();
                                    lbl.scrollTop(0);

                                    // Eingabefeld leeren
                                    $("#txtNeuerKommentar").val("");
                                },
                                callbackError: (ajaxResult) => {
                                    console.log(ajaxResult);
                                }
                            });
                        }
                    }
                });

                $('#addLeistungsnachweis').off("click");
                $("#addLeistungsnachweis").on("click", function () {
                    const $this = $(this);
                    const id = $this.data("id");
                    $(`#addLN-placeholder`).html("");

                    new dbh_ajax().sendGetRequest({
                        actionName: "GetAddLeistungsnachweisPopupView",
                        controllerName: "Leistungsnachweise",
                        parameter: [["id", id]],
                        callbackSuccess: (ajaxResult: any) => {
                            $(`#addLN-placeholder`).html(ajaxResult.responseText);
                        },
                        callbackError: (ajaxResult: object) => {

                        }
                    });
                })

                $('#addBetreuungsbericht').off("click");
                $("#addBetreuungsbericht").on("click", function () {
                    const $this = $(this);
                    const id = $this.data("id");
                    $(`#addBetreuungsbericht-placeholder`).html("");

                    new dbh_ajax().sendGetRequest({
                        actionName: "GetAddBetreuungsberichtPopupView",
                        controllerName: "Belegungen/Betreuungsberichte",
                        parameter: [["id", id]],
                        callbackSuccess: (ajaxResult: any) => {
                            $(`#addBetreuungsbericht-placeholder`).html(ajaxResult.responseText);
                        },
                        callbackError: (ajaxResult: object) => {

                        }
                    });
                })

                $('#addDokument').off("click");
                $("#addDokument").on("click", function () {
                    $('#addDokument-placeholder').html("");

                    new dbh_ajax().sendGetRequest({
                        actionName: "AddDokumentPopupView",
                        controllerName: "Belegungen",
                        parameter: [["id", id]],
                        callbackSuccess: (ajaxResult: any) => {
                            $('#addDokument-placeholder').html(ajaxResult.responseText);
                            $('#AddDokumentViewComponentPopup').fadeIn("fast");
                        },
                        callbackError: (ajaxResult: object) => {

                        }
                    });
                });

                $('.btnDokumentLoeschen').off("click");
                $('.btnDokumentLoeschen').on('click', (e) => {

                    new dbh_ajax().sendGetRequest({
                        actionName: "GetDokumentEntfernenPopupView",
                        controllerName: "Belegungen",
                        parameter: [["id", $(e.target).attr('data-id')]],
                        callbackSuccess: (ajaxResult: any) => {
                            $('#deleteDokument-placeholder').html(ajaxResult.responseText);
                            (window as any).showPopup("GetDokumentEntfernenPopupView");

                            $("#deleteDokument-placeholder").ready(function () {
                                $('#btnPrimaryBelegungenDokumentEntfernen').on('click', (e) => {
                                    var form = dbh_helper.findNearestForm(e.target);

                                    new dbh_ajax().sendPostRequest({
                                        csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                                        actionName: "DeleteDokument",
                                        controllerName: "Belegungen",
                                        parameter: dbh_helper.getParameterStringForForm(form),
                                        callbackSuccess: (ajaxResult: any) => {
                                            window.location.reload();
                                        },
                                        callbackError: (ajaxResult: any) => {

                                            $('#dbhErrorDokumentEntfernen').html(ajaxResult.responseJSON.message).show();
                                        }
                                    });

                                    e.stopPropagation();
                                });
                            });
                        },
                        callbackError: (ajaxResult: object) => {
                        }
                    });

                    e.stopPropagation();
                });

                $('.dbh_action.endBelegung').off("click");
                $('.dbh_action.endBelegung').on("click", function () {
                    new dbh_ajax().sendGetRequest({
                        actionName: "GetEndBelegungPopupView",
                        controllerName: "Belegungen",
                        parameter: [["id", id]],
                        callbackSuccess: (ajaxResult: any) => {
                            $(`#endBelegung-placeholder`).html(ajaxResult.responseText);
                            $('#EndBelegungViewComponentPopup').fadeIn("fast");

                            $("#BelegungNeuBeginnen").on("change", function () {
                                const $this = $(this);
                                if ($this.prop("checked")) {
                                    $(".endBelegungStartNew-container").addClass("active");
                                }
                                else {
                                    $(".endBelegungStartNew-container").removeClass("active");
                                }
                            })
                        },
                        callbackError: (ajaxResult: object) => {
                        }
                    });
                })

                //$('.dbh_action.infokarteDrucken').off("click");
                //$('.dbh_action.infokarteDrucken').on("click", function () {
                //    new dbh_ajax().sendGetRequest({
                //        actionName: "InfokarteDrucken",
                //        controllerName: "Belegungen",
                //        parameter: [["id", id]],
                //        callbackSuccess: (ajaxResult: any) => {
                //        },
                //        callbackError: (ajaxResult: object) => {
                //        }
                //    });
                //})

                $('.dbh_action.belegungLoschen').off("click");
                $('.dbh_action.belegungLoschen').on("click", function () {
                    new dbh_ajax().sendGetRequest({
                        actionName: "GetBelegungLoeschenPopupView",
                        controllerName: "Belegungen",
                        parameter: [["id", id]],
                        callbackSuccess: (ajaxResult: any) => {
                            $(`#belegungLoeschen-placeholder`).html(ajaxResult.responseText);
                            $('#BelegungLoeschenViewComponentPopup').fadeIn("fast");
                        },
                        callbackError: (ajaxResult: object) => {
                        }
                    });
                })

                $('.dbh_action.belegungAendern').off("click");
                $('.dbh_action.belegungAendern').on("click", function () {
                    new dbh_ajax().sendGetRequest({
                        actionName: "GetBelegungAnpassungOverlayView",
                        controllerName: "Belegungen",
                        parameter: [["id", id]],
                        callbackSuccess: (ajaxResult: any) => {
                            $(`#belAnpassen-placeholder`).html(ajaxResult.responseText);
                            $("#belegungAendernOverlay").addClass("active");
                            $(".hideOnShowOverlay").hide();
                            $('#belegungAendernOverlay .form-text-datepicker').each(function () {
                                const $this = $(this);
                                //$this.on('focus', dbh_helper.SetEnglishDateFormat);
                                //$this.on('blur', dbh_helper.SetGermanDateFormat);
                                $this.on('change focusout', function () {
                                    const startDateElement = $(".startDate");
                                    const endDateElement = $(".endDate");
                                    const isStartChange = $(this).hasClass("startDate");
                                    const isEndChange = $(this).hasClass("endDate");

                                    let newStartBelegung = null;
                                    let newEndBelegung = null;
                                    let oldStartDate = null;
                                    let oldEndDate = null;
                                    let showInfo = true;

                                    let isDate = false;

                                    if (startDateElement.length > 0) {
                                        let currentStartDate = startDateElement.val().toString();
                                        oldStartDate = startDateElement.data().date.toString();

                                        /*Aktuellen Wert der Datumsfelder anpassen*/
                                        startDateElement.prop("value", currentStartDate);
                                        /*Datumsformate anpassen*/
                                        if (currentStartDate.indexOf(".") >= 0) {
                                            currentStartDate = currentStartDate.split(".").reverse().join("-");
                                        }

                                        newStartBelegung = new Date(currentStartDate);
                                        showInfo = showInfo && currentStartDate === oldStartDate;
                                    }

                                    if (endDateElement.length > 0 || (endDateElement.length == 0 && endDateElement.data()?.date.toString().length > 0)) {
                                        let currentEndDate = endDateElement.val().toString();
                                        oldEndDate = endDateElement.data().date.toString();

                                        /*Aktuellen Wert der Datumsfelder anpassen*/
                                        endDateElement.prop("value", currentEndDate);

                                        if (currentEndDate.length > 0) {
                                            /*Datumsformate anpassen*/
                                            if (currentEndDate.indexOf(".") >= 0) {
                                                currentEndDate = currentEndDate.split(".").reverse().join("-");
                                            }

                                            //Passe neue Datums-Angaben an
                                            newEndBelegung = new Date(currentEndDate);
                                        }
                                        showInfo = showInfo && currentEndDate === oldEndDate;
                                    }

                                    /*Bei keiner Änderung wird die Anzeige reduziert*/
                                    if (showInfo) {
                                        $(".hiddenRow").removeClass("active");
                                    }
                                    else {
                                        $(".hiddenRow").addClass("active");
                                    }

                                    console.log(isStartChange);
                                    console.log(newStartBelegung instanceof Date);
                                    isDate = (isStartChange && newStartBelegung instanceof Date)
                                        || (!isStartChange && newEndBelegung instanceof Date)

                                    if (isDate) {
                                        // Passe Datums-Felder bei den Belegungen und Sachkosten an
                                        if (isStartChange && startDateElement.length > 0 && IsValidDate(newStartBelegung)) {
                                            SetBelegungValues(newStartBelegung, false, $(".dateEndePrev"), $("#BelegungVorher_Ende"), $("#BelegungVorher_Start"), $(".dateStartPrev"));
                                            SetSachkostenDateValues('#Sachkosten_', '__Von', oldStartDate, newStartBelegung, true);
                                            //SetSachkostenDateValues('#Sachkosten_', '__Bis', oldEndDate, newStartBelegung, true);
                                        }
                                        if (isEndChange && endDateElement.length > 0 && IsValidDate(newEndBelegung)) {
                                            SetBelegungValues(newEndBelegung, true, $(".dateStartNext"), $("#BelegungNachher_Start"), $("#BelegungNachher_Ende"), $(".dateEndeNext"));
                                            //SetSachkostenDateValues('#Sachkosten_', '__Von', oldStartDate, newEndBelegung, false);
                                            SetSachkostenDateValues('#Sachkosten_', '__Bis', oldEndDate, newEndBelegung, false);
                                        }

                                        /*Passe Datumsfelder der Betreuer an*/
                                        SetBetreuerValues(newStartBelegung, newEndBelegung, oldStartDate, oldEndDate);
                                    }
                                    else if (isEndChange) {
                                        SetBelegungValues(null, true, $(".dateStartNext"), $("#BelegungNachher_Start"), $("#BelegungNachher_Ende"), $(".dateEndeNext"));
                                        SetSachkostenDateValues('#Sachkosten_', '__Bis', oldEndDate, null, false);
                                        SetBetreuerValues(newStartBelegung, null, oldStartDate, oldEndDate);
                                    }
                                });
                            });
                        },
                        callbackError: (ajaxResult: object) => {
                        }
                    });
                })

                $('#addTagebuchBtn').off("click");
                $("#addTagebuchBtn").on("click", function () {
                    const $this = $(this);
                    const key = $this.data().key;
                    new dbh_ajax().sendGetRequest({
                        actionName: "GetAddTagebucheintragPopupView",
                        controllerName: "Belegungen",
                        parameter: [["id", key], ["idBelegung", id]],
                        callbackSuccess: (ajaxResult: any) => {
                            $(`#addTagebuch-placeholder`).html(ajaxResult.responseText);
                            $('#AddEintragViewComponentPopup').fadeIn("fast");
                        },
                        callbackError: (ajaxResult: object) => {

                        }
                    });
                });

                $('#addNewBetreuer').off("click");
                $("#addNewBetreuer").on("click", function () {
                    new dbh_ajax().sendGetRequest({
                        actionName: "GetAddBetreuerPopupView",
                        controllerName: "Belegungen",
                        parameter: [["id", id]],
                        callbackSuccess: (ajaxResult: any) => {

                            console.log(ajaxResult.responseText);

                            $(`#betreuerIn-placeholder`).html(ajaxResult.responseText);
                            $('#AddBetreuerInViewComponentPopup').fadeIn("fast");
                        },
                        callbackError: (ajaxResult: object) => {

                        }
                    });
                });

                $(document).on('click', '#changeBetreuerSubmit', function (e) {
                    const form = dbh_helper.findNearestForm(e.currentTarget);

                    let dbhCustomValidation = new dbh_custom_validation();
                    if (!dbhCustomValidation.validateForm(form)) {
                        return;
                    }

                    const parameter = dbh_helper.getParameterStringForForm(form);
                    dbh_helper.FormatDatesParameterArray(parameter);

                    dbh_helper.SendPostRequest('ChangeBetreuer', 'Belegungen', parameter, null, () => {
                        new dbh_suchergebnis().defaultReloadSearchResult($('#BetreuerTabelleMitSuche .dbhSuchergebnis').first().get(0));
                        $("#ChangeBetreuerInViewComponentPopup").hide();
                    });
                });
                                
                $(document).on('click', '#editBetreuerSubmit', function (e) {
                    const form = dbh_helper.findNearestForm(e.currentTarget);

                    let dbhCustomValidation = new dbh_custom_validation();
                    if (!dbhCustomValidation.validateForm(form)) {
                        return;
                    }

                    const parameter = dbh_helper.getParameterStringForForm(form);
                    dbh_helper.FormatDatesParameterArray(parameter);

                    dbh_helper.SendPostRequest('EditBetreuer', 'Belegungen', parameter, null, () => {
                        new dbh_suchergebnis().defaultReloadSearchResult($('#BetreuerTabelleMitSuche .dbhSuchergebnis').first().get(0));
                        $("#EditBetreuerInViewComponentPopup").hide();
                    });
                });
                $('#addAbwesenheit').off("click");
                $("#addAbwesenheit").on("click", function () {
                    new dbh_ajax().sendGetRequest({
                        actionName: "AddAbwesenheitPopupView",
                        controllerName: "Belegungen",
                        parameter: [["belegung", $(this).data().belegung], ["jugendlicher", $(this).data().jugendlicher]],
                        callbackSuccess: (ajaxResult: any) => {
                            $('#addAbwesenheit-placeholder').html(ajaxResult.responseText);
                            $('#AddAbwesenheitViewComponentPopup').fadeIn("fast");
                        },
                        callbackError: (ajaxResult: object) => {

                        }
                    });
                });

                $(document).on("click", ".dbhTableBetreuerEditBtn", function () {
                    const actionName = "GetEditBetreuerPopupView";
                    const popupId = "EditBetreuerInViewComponentPopup";
                    const betId = $(this).data("id");
                    DoSendRequestForBetreuer(actionName, betId, popupId);
                });

                $(document).on("click", ".dbhTableBetreuerEdit2Btn", function () {
                    const actionName = "GetChangeBetreuerPopupView";
                    const popupId = "ChangeBetreuerInViewComponentPopup";
                    const betId = $(this).data("id");
                    DoSendRequestForBetreuer(actionName, betId, popupId);
                });

                $(document).on("click", ".Betreuer_BelegungenSuchenModel .tableDeleteButton ", function () {
                    const actionName = "GetDeleteBetreuerPopupView";
                    const popupId = "DeleteBetreuerInViewComponentPopup";
                    const betId = $(this).closest("tr").data("rowid");
                    DoSendRequestForBetreuer(actionName, betId, popupId);
                });

                $("#typescriptAbwesenheitTableProxy").on("click", function (event, type, id) {

                })

                $("#typescriptAddLnProxy").on("click", function (event, id, year, month, htmlId) {
                    var error = false;
                    new dbh_ajax().sendGetRequest({
                        actionName: "AddLeistungsnachweis",
                        controllerName: "Leistungsnachweise",
                        parameter: [["id", id], ["year", year], ["month", month]],
                        callbackSuccess: (ajaxResult: any) => {
                            if (!error) {
                                window.location.href = "/Leistungsnachweise/Details?id=" + ajaxResult.responseText.toString().replaceAll("\"", "");
                            }
                        },
                        callbackError: (ajaxResult: any) => {
                            $(htmlId).html(ajaxResult.responseText);
                            error = true;
                        }
                    });
                });

                $("#typescriptAddBetreuungsberichtProxy").on("click", function (event, id, year, month, htmlId) {
                    var error = false;
                    new dbh_ajax().sendGetRequest({
                        actionName: "AddBetreuungsbericht",
                        controllerName: "Belegungen/Betreuungsberichte",
                        parameter: [["id", id], ["year", year], ["month", month]],
                        callbackSuccess: (ajaxResult: any) => {
                            if (!error) {
                                window.location.href = "/Belegungen/Betreuungsberichte/Details?id=" + ajaxResult.responseText.toString().replaceAll("\"", "");
                            }
                        },
                        callbackError: (ajaxResult: any) => {
                            $(htmlId).html(ajaxResult.responseText);
                            error = true;
                        }
                    });
                });

                $("#typescriptReInitCustomeValidators").on("click", function () {
                    let dbhCustomValidation = new dbh_custom_validation();
                    dbhCustomValidation.initClientValidators();
                    console.log("Re-Init Custom-Validation");

                })

                HideOptionsValuesInDependendSelection($('#FK_ZJ'));
                HideOptionsValuesInDependendSelection($('#FK_RS'));
                HideOptionsValuesInDependendSelection($('#FK_FS'));
                HideOptionsValuesInDependendSelection($('#FK_Wirt'));

                $('.dbh_amt').change(function () {
                    var id = $(this)
                    $(id.attr('data-for')).val($(id.attr('data-for')).children()[0].toString());
                    $(id.attr('data-for')).children().each(function (i, item) {
                        item.hidden = true;

                        if (item.getAttribute('data-fkja') == id.val()) {
                            item.hidden = false;
                        }
                    });
                });

                dbh_helper.SetOnDateChangeAndSetMinAsTomorrowForFollowingDate("#KontingentVon", "#KontingentBis", false);
                
                dbh_helper.SetOnDateChangeAndSetMinAsTomorrowForFollowingDate("#KostenzusageVon", "#KostenzusageBis", false);

                $('.btnCancel').off("click");
                $(".btnCancel").on("click", function () {
                    /*window.location.href = "/belegungen/suchen";*/
                    location.reload();
                });

                $(document).ready(function () {
                    /* Belegung-Historie zur aktuellen Belegung scrollen */
                    const curSelectedBelegung = document.getElementById("curSelectedBelegung");
                    if (curSelectedBelegung) {
                        /* vanilla-js, da hier der absoulte left-Wert geladen wird (und nicht der visuelle) */
                        const offsetLeft = curSelectedBelegung.offsetLeft
                        document.getElementById("belegungSelectionContainer").scrollLeft = offsetLeft;
                    }
                });
            }
        }
    });

    $(document).ready(function () {
        $('#BetreuerAktiv').change(function () {
            initSearchCHeckboxOnChange($(this), $("#FK_Betreuer"), "GetBetreuerOptions");
        })

        $('#BetreuteAktiv').change(function () {
            initSearchCHeckboxOnChange($(this), $("#FK_Jugendlicher"), "GetBetreuterOptions");
        })


        /*###############################################*/

        /*Tagbuch - Monat ändern START*/
        $(document).on('click', '.diary-month-switch .month-prev', function (e) {
            let month = +$('#Month').val() - 1;
            let year = +$('#Year').val()
            if (month < 1) {
                month = 12;
                year--;
            }

            loadNextMonth($('#Pk_Adressen').val(), $('#Pk_Wohnungen').val(), month, year);
        });

        $(document).on('click', '.diary-month-switch .month-next', function (e) {
            let month = +$('#Month').val() + 1;
            let year = +$('#Year').val()
            if (month > 12) {
                month = 1;
                year++;
            }

            loadNextMonth($('#Pk_Adressen').val(), $('#Pk_Wohnungen').val(), month, year);
        });
        /*Tagbuch - Monat ändern ENDE*/

        /*###############################################*/
    });

    $("#dbh_SachkostenDetails").ready(function () {

        $("#typescriptSachkostenDetailsValidProxy").on("click", function (event, formId, elementToClickId) {
            let dbhCustomValidation = new dbh_custom_validation();
            if (dbhCustomValidation.validateForm(formId)) {
                $(elementToClickId).trigger("click");
            }
        });
    });
}

const loadNextMonth = (id, pk_Zimmer, month: number, year: number) => {
    new dbh_ajax().sendGetRequest({
        actionName: "LoadDiaryForMonth",
        controllerName: "Belegungen",
        parameter: [['id', id], ['pk_Zimmer', pk_Zimmer], ["month", `${month}`], ["year", `${year}`]],
        callbackSuccess: (ajaxResult: any) => {
            $(`#TagebuchTabelleMitSuche`).html(ajaxResult.responseText);
        },
        callbackError: (ajaxResult: object) => {
        }
    });
}

const DoSendRequestForBetreuer = (actionName, betId, popupId) => {
    new dbh_ajax().sendGetRequest({
        actionName: actionName,
        controllerName: "Belegungen",
        parameter: [["id", betId]],
        callbackSuccess: (ajaxResult: any) => {
            $(`#betreuerIn-placeholder`).html(ajaxResult.responseText);
            $(`#${popupId}`).fadeIn("fast");
        },
        callbackError: (ajaxResult: object) => {

        }
    });
}

const BindTableAndPopupFunctions = (belegId) => {
    /*Abwesenheiten*/
    initAbwesenheitenPopupFunctions();
    initAbwesenheitenTableEditDelete();

    dbh_helper.SetOnDateChangeAndSetMinAsTomorrowForFollowingDate("#EndeAktuelleBelegung", "#StartdatumNeueBelegung", true);
}

const initAbwesenheitenPopupFunctions = () => {
    $("#btnAddAbwesenheit").off("click");
    $("#btnAddAbwesenheit").on("click", function (e) {
        var form = dbh_helper.findNearestForm(e.currentTarget);
        sendPostRequestForAbwesenheit(form, "AddAbwesenheit", "AddAbwesenheitViewComponentPopup");
    });

    $("#btnSaveAbwesenheit").off("click");
    $("#btnSaveAbwesenheit").on("click", function (e) {
        var form = dbh_helper.findNearestForm(e.currentTarget);
        sendPostRequestForAbwesenheit(form, "EditAbwesenheit", "EditAbwesenheitViewComponentPopup");
    });

    $("#delAbwesenheit").off("click");
    $("#delAbwesenheit").on("click", function (e) {
        var form = dbh_helper.findNearestForm(e.currentTarget);
        sendPostRequestForAbwesenheit(form, 'DeleteAbwesenheit', 'DeleteAbwesenheitViewComponentPopup');
    });
}

const initAbwesenheitenTableEditDelete = () => {
    $('.AbwesenheitenSuchenModel *[data-rowid]').off('click');
    initAbwesenheitTableCellClicks("edit", "AbwesenheitenSuchenModel");

    $('.AbwesenheitenSuchenModel .tableDeleteElement').off("click");
    $('.AbwesenheitenSuchenModel .tableDeleteElement').on("click", function () {
        const id = $(this).closest("tr").data("rowid");
        editDeleteAbwesenheit(id, "delete");
    });
}

const initAbwesenheitTableCellClicks = (type, tableContainer: string) => {
    const clickElements = dbh_helper.InitTableClickedElements(tableContainer);
    for (let i = 0; i < clickElements.length; i++) {
        $(clickElements[i][0]).on("click", function (e) {
            editDeleteAbwesenheit(clickElements[i][1], type);
        });
    }
}

const sendPostRequestForAbwesenheit = (form, action, popupId) => {
    new dbh_ajax().sendPostRequest({
        csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
        actionName: action,
        controllerName: "Belegungen",
        parameter: dbh_helper.getParameterStringForForm(form),
        callbackSuccess: (ajaxResult: any) => {
            (window as any).hidePopup(popupId);
            // reload Nachrichten Tabelle                                        
            new dbh_suchergebnis().defaultReloadSearchResult($('#AbwesenheitenTabelleMitSuche .dbhSuchergebnis').first().get(0));
        },
        callbackError: (ajaxResult: any) => {
        }
    });
}

const editDeleteAbwesenheit = (id, type) => {
    let actionName = '';
    let popupId = '';

    switch (type) {
        case 'delete':
            actionName = "DeleteAbwesenheitPopupView";
            popupId = "DeleteAbwesenheitViewComponentPopup";
            break;
        default:
            actionName = "EditAbwesenheitPopupView";
            popupId = "EditAbwesenheitViewComponentPopup";
            break;
    }

    new dbh_ajax().sendGetRequest({
        actionName: actionName,
        controllerName: "Belegungen",
        parameter: [["id", id]],
        callbackSuccess: (ajaxResult: any) => {
            $(`#abwesenheit-placeholder`).html(ajaxResult.responseText);
            $(`#${popupId}`).fadeIn("fast");
        },
        callbackError: (ajaxResult: object) => {

        }
    });
}

const initSearchCHeckboxOnChange = ($element, $idSelect, actionname) => {
    const isAktiv = $element.is(":checked") ? "1" : "0";
    const selectElement = $idSelect;
    selectElement.addClass("disableWhileLoading");

    new dbh_ajax().sendGetRequest({
        actionName: actionname,
        controllerName: "Belegungen",
        parameter: [["onlyAktiv", isAktiv]],
        callbackSuccess: (ajaxResult: any) => {
            selectElement.html(ajaxResult.responseText)
            selectElement.removeClass("disableWhileLoading");
        },
        callbackError: (ajaxResult: object) => {
            selectElement.removeClass("disableWhileLoading");
        }
    });
}

const HideOptionsValuesInDependendSelection = (id) => {
    $(id.attr('data-for')).children().each(function (i, item) {
        item.hidden = true;

        if (item.getAttribute('data-fkja') == id.val()) {
            item.hidden = false;
        }
    });
}

const IsValidDate = (d: Date) => {
    return d instanceof Date && !isNaN(d?.getTime());
}

const GetCopyOfDate = (d: Date) => {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

const GetDateAsString = (d: Date) => {
    const day = d.getDate();
    const month = d.getMonth() + 1;
    const currentMonthString = month < 10 ? `0${month}` : `${month}`;
    const currentDateString = day < 10 ? `0${day}` : `${day}`;

    return `${currentDateString}.${currentMonthString}.${d.getFullYear()}`;
}

const SetBelegungValues = (date: Date, isNext: boolean, $dateText, $dateHidden, $dateTextUnchanged, $dateHiddenUnchanged) => {
    if (date != null) {
        let newDate = GetCopyOfDate(date);
        const addDayValue = isNext ? 1 : -1;
        newDate.setDate(date.getDate() + addDayValue)

        // Setzen des veränderten Datumswert
        if ($dateText.length > 0 && $dateHidden.length > 0) {
            $dateText.text(GetDateAsString(newDate));
            $dateHidden.val(GetDateAsString(newDate));
        }
    }
    else {
        // Setzen des veränderten Datumswert
        if ($dateText.length > 0 && $dateHidden.length > 0) {
            $dateText.text("");
            $dateHidden.val("");
        }
    }

    // Laden des unveränderten Wertes
    if ($dateTextUnchanged.length > 0 && $dateHiddenUnchanged.length > 0) {
        const currentDateEndNext = $dateTextUnchanged.val().toString();
        $dateHiddenUnchanged.text(currentDateEndNext.length > 0 ? currentDateEndNext.replace(" 00:00:00", "") : "Bisher offen");
    }
}

const SetBetreuerValues = (startdate: Date, enddate: Date, initialStartData: Date, initialEndData: Date) => {
    let betreuerCounter = 0;
    let betreuerFound = true;

    if (new Date(startdate).toString() !== 'Invalid Date' && startdate.getFullYear() > 1970) {
        SetBetreuerDateValues('#Betreuer_', '__Von', initialStartData, startdate);
    }

    if (enddate == null || (new Date(enddate).toString() !== 'Invalid Date' && enddate.getFullYear() > 1970)) {
        SetBetreuerDateValues('#Betreuer_', '__Bis', initialEndData, enddate);
    }
}

const SetBetreuerDateValues = (idValuePrefix, idValueSuffix, initialData, dateToSet) => {
    let betreuerCounter = 0;
    let betreuerFound = true;

    while (betreuerFound) {
        let betreuerIdValue = `${idValuePrefix}${betreuerCounter}${idValueSuffix}`;
        const element = $(betreuerIdValue);

        if (element.length === 0) {
            betreuerFound = false;
            break;
        }
        const value = element.val().toString()
        const array = value.replace(" 00:00:00", "").split(".");
        let date = new Date(+array[2], +array[1] - 1, +array[0]);
        let initialVonBisData = element.data().date.toString();

        if (IsValidDate(date)) {
            const initialDate = GetDateFromData(initialData);
            const initialVonBisDate = GetDateFromData(initialVonBisData);

            // Wenn das ursprüngl. Startdatum == dem ursprüngl. Von-Datum, dann wird jeder Wert aus dem neuen Startdatum übernommen
            if (CompareDates(initialVonBisDate, initialDate) === 0) {
                element.val(dateToSet != null ? GetDateAsString(dateToSet) : "");
                $(`[data-for='${betreuerIdValue}']`).text(dateToSet != null ? GetDateAsString(dateToSet) : "");
            } else if (dateToSet != null && CompareDates(initialVonBisDate, dateToSet) === -1) {
                // Prüfen, ob Betreuer.Von kleiner als Starttermin -> neuer Von-Termin
                element.val(dateToSet != null ? GetDateAsString(dateToSet) : "");
                $(`[data-for='${betreuerIdValue}']`).text(dateToSet != null ? GetDateAsString(dateToSet) : "");
            } else {
                // alter Wert wird wieder gesetzt
                element.val(GetDateAsString(initialVonBisDate));
                $(`[data-for='${betreuerIdValue}']`).text(GetDateAsString(initialVonBisDate));
            }

        }
        betreuerCounter++;
    }
}

const SetSachkostenDateValues = (idValuePrefix, idValueSuffix, initialData, dateToSet, isStartChange) => {
    let sachkostenCounter = 0;
    let sachkostenFound = true;

    while (sachkostenFound) {
        let sachkostenIdValue = `${idValuePrefix}${sachkostenCounter}${idValueSuffix}`;
        const element = $(sachkostenIdValue);

        if (element.length === 0) {
            sachkostenFound = false;
            break;
        }

        const value = element.val().toString()
        const array = value.replace(" 00:00:00", "").split(".");
        let date = new Date(+array[2], +array[1] - 1, +array[0]);
        let initialVonBisData = element.data().date.toString();

        if (IsValidDate(date)) {
            const $span = $(`[data-for='${sachkostenIdValue}']`);
            const initialDate = GetDateFromData(initialData);
            const initialVonBisDate = GetDateFromData(initialVonBisData);
            /* Sachkosten werden nur angezeigt, wenn das Von/Bis-Datum gleich oder um einen Tag höher/niedriger ist
             Dementsprechend muss auf zwei Tage geprüft werden */
            const initialVonBisDate2 = GetCopyOfDate(initialVonBisDate);

            initialVonBisDate2.setDate(initialVonBisDate.getDate() + (isStartChange ? 1 : -1));

            // Wenn das ursprüngl. Startdatum == dem ursprüngl. Von-Datum, dann wird jeder Wert aus dem neuen Datum übernommen
            if (CompareDates(initialVonBisDate, initialDate) === 0 || CompareDates(initialVonBisDate2, initialDate) === 0) {
                element.val(dateToSet != null ? GetDateAsString(dateToSet) : "");
                $span.html(dateToSet != null ? GetDateAsString(dateToSet) : "");
            }
        }

        sachkostenCounter++;
    }
}

const CompareDates = (date1: Date, date2: Date) => {
    // Uhrzeiten bereinigen
    const reducedDate1 = GetCopyOfDate(date1);
    const reducedDate2 = GetCopyOfDate(date2);

    if (reducedDate1.getTime() > reducedDate2.getTime()) {
        return 1;
    }
    if (reducedDate1.getTime() < reducedDate2.getTime()) {
        return -1;
    }

    return 0
}

const GetDateFromData = (data) => {
    if (data) {
        return new Date(+data.toString().split("-")[0], +data.toString().split("-")[1] - 1, +data.toString().split("-")[2]);
    }
    else { return new Date(); }
}

